import { Component, EventEmitter, Input, Output } from '@angular/core';

interface GridSlide {
  title: string;
  /** Short text shown in the card listing */
  description: string;
  /** Full (rich-text) description shown in the modal when the card is clicked */
  fullDescription?: string;
  image: string;
  url: string;
  bgType: 'none' | 'color' | 'image';
  backgroundColor?: string;
  backgroundColorHover?: string;
  hasImage: boolean;
}

@Component({
  selector: 'app-sblock-sliders-grid',
  templateUrl: './sliders-grid.component.html',
  styleUrls: ['./sliders-grid.component.scss']
})
export class SblockSlidersGridComponent {
  titlesColor = '#2c3e50';
  secondaryColor = '#d9534f';

  gridColClass = 'col-md-4';

  /** Shows skeleton placeholders while the parent is fetching data */
  @Input() loading = false;

  /** Content comes from the parent; no placeholder/demo fallbacks */
  @Input() title = '';
  @Input() subtitle = '';
  @Input() slides: GridSlide[] = [];

  /** Emitted when a card without a real link (url empty or '#') is clicked */
  @Output() slideClick = new EventEmitter<GridSlide>();

  /** Number of skeleton cards rendered while loading */
  skeletonCards = [0, 1, 2];

  onCardClick(slide: GridSlide, event: Event): void {
    // Cards without a real link (e.g. value propositions) open the modal
    // instead of navigating.
    if (!slide.url || slide.url === '#') {
      event.preventDefault();
      this.slideClick.emit(slide);
    }
  }
}
